module.exports = __webpack_public_path__ + "static/media/Plus.e11c9b28.svg";